import VueResource from 'vue-resource';
import Vue from 'vue';

Vue.use(VueResource);

const urlPrefix = `${window.location.origin}${window.SITE_URL}`;

export default {
  getTransactions(params) {
    const query = {};
    Object.keys(params).forEach((filterAttr) => {
      const queryKey = filterAttr.replace(
        /([A-Z])/g,
        m1 => `_${m1.toLowerCase()}`,
      );
      query[queryKey] = params[filterAttr];
    });
    const url = new URL('transaction/json', urlPrefix);
    return Vue.http.get(url.href, {
      params: query,
    }).then(res => res.json());
  },

  getOverallTransactions() {
    const url = new URL('transaction/json', urlPrefix);
    return Vue.http.get(url.href, {
    }).then(res => res.json());
  },

  getTransactionKeywords(query) {
    const params = {
      ...query,
      limit: 14,
      lang: window.lang,
    };
    const url = new URL('api/tx_keyword', urlPrefix);
    return Vue.http.get(url.href, {
      params,
    }).then(res => res.json());
  },

  getKeywordByPisBldgId(icsType, pisBldgId, lang) {
    const params = {
      ics_type: icsType,
      pis_bldg_id: pisBldgId,
      lang,
    };
    const url = new URL('api/tx_keyword_by_pis_bldg_id', urlPrefix);
    return Vue.http.get(url.href, {
      params,
    }).then(res => res.json());
  },
};
